import { gql } from '@apollo/client';
import { AnyEventFieldsFragment } from '../../../utils/apollo/events/any';

export default gql`
  query GetAnyEvent {
    anyEvent {
      ...AnyEventFields
    }
  }

  ${AnyEventFieldsFragment}
`;
